const data = {
  mercatoOptions: [
    { code: "4.1a", description: "Retail" },
    { code: "4.2a", description: "Private" },
    { code: "4.3a", description: "Business/Imprese e Corporate" }
  ],
  destinatariOptions: [
    { code: "4.1b", description: "Persone Fisiche" },
    { code: "4.2b", description: "Persone Giuridiche" },
    { code: "4.3b", description: "Persone Fisiche + Persone Giuridiche" }
  ],
  canaleOptions: [
    { code: "5.1", description: "Banca" },
    { code: "5.2", description: "Consulenti Finanziari" },
    { code: "5.3", description: "Banca + Consulenti Finanziari" }
  ],
  tipoProdottoOptions: [
    { code: "6.1", description: "Unit Linked Classica" },
    { code: "6.2", description: "Unit Linked Protetta" },
    { code: "6.3", description: "Unit Linked Ibrida" },
    { code: "6.4", description: "Index Linked" },
    { code: "6.5", description: "Multiramo" },
    { code: "6.6", description: "Ramo I - Rivalutabile" },
    { code: "6.7", description: "Ramo I - Rendita" },
    { code: "6.8", description: "Ramo V" },
    { code: "6.9", description: "PIP" },
    { code: "6.10", description: "Variable Annuity" },
    { code: "6.11", description: "PIR – Tradizionale" },
    { code: "6.12", description: "PIR – Multiramo" },
    { code: "6.13", description: "PIR – Unit" }
  ],
  tipoSottostantiOptions: [
    { code: "7.1", description: "Gestione Separata" },
    { code: "7.2", description: "Fondi Interni" },
    { code: "7.3", description: "OICR" },
    { code: "7.4", description: "ETF" },
    { code: "7.5", description: "Gestione Separata + Fondi Interni" },
    { code: "7.6", description: "Gestione Separata + OICR" },
    { code: "7.7", description: "Gestione Separata + ETF" },
    {
      code: "7.8",
      description: "Gestione Separata + Fondi Interni + OICR + ETF"
    },
    {
      code: "7.9",
      description: "Gestione Separata + Fondi Interni + OICR"
    },
    {
      code: "7.10",
      description: "Gestione Separata + Fondi Interni + ETF"
    },
    { code: "7.11", description: "Gestione Separata + OICR + ETF" },
    { code: "7.12", description: "Fondi Interni + OICR + ETF" },
    { code: "7.13", description: "Fondi Interni + OICR" },
    { code: "7.14", description: "Fondi Interni + ETF" },
    { code: "7.15", description: "OICR + ETF" }
  ],

  prodCommOptions: [
    { code: "9.1", description: "Sì" },
    { code: "9.2", description: "No" }
  ],

  tipoPremioOptions: [
    { code: "11.1a", description: "PIC" },
    { code: "11.2a", description: "PAC" }
  ],

  prodCollegatoOptions: [
    { code: "11.1b", description: "Sì" },
    { code: "11.2b", description: "No" }
  ],

  relazioneProdCollegatoOptions: [
    { code: "11.1d", description: "Principale" },
    { code: "11.2d", description: "Secondario" },
    { code: "11.3d", description: "Paritetico" },
    { code: "11.4d", description: "Alternativo" }
  ],

  tipologiaDurationOptions: [
    { code: "13.1", description: "Vita intera" },
    { code: "13.2", description: "Scadenza" },
    { code: "13.3", description: "Durata fissa in anni" },
    { code: "13.4", description: "Range Durata" },
    { code: "13.5", description: "Campo note" }
  ],

  tipoCalcoloBonusIngressoOptions: [
    { code: "22.1", description: "Percentuale fissa" },
    { code: "22.2", description: "Fasce cumulo premi versati" },
    { code: "22.3", description: "Fasce a scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "22.4", description: "Fasce premi versati annui" },
    { code: "22.5", description: "Classi patrimonio potenziale" },
    { code: "22.6", description: "Non presente" },
    { code: "22.7", description: "Campo note" }
  ],
  tipoCalcoloBonusFedeltaOptions: [
    { code: "24.1", description: "Capitale" },
    { code: "24.2", description: "Premi netti versati" },
    { code: "24.3", description: "Non presente" },
    { code: "24.4", description: "Campo note" },
  ],
  tipologiaUpfrontFeeOptions: [
    { code: "28.1", description: "Percentuale fissa" },
    { code: "28.2", description: "Fasce cumulo premi versati" },
    { code: "28.3", description: "Fasce a scaglioni cumulo premi versati (criterio Irpef)" },
    { code: "28.4", description: "Fasce premi versati annui" },
    { code: "28.5", description: "Percentuale funzione del tempo" },
    { code: "28.6", description: "Fasce cumulo premi versati funzione del tempo" },
    { code: "28.7", description: "Fasce a scaglioni cumulo premi versati (criterio Irpef) funzione del tempo" },
    { code: "28.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "28.9", description: "Classi patrimonio potenziale" },
    { code: "28.10", description: "Classi patrimonio potenziale e fasce premi versati" },
    { code: "28.11", description: "Non presente" },
    { code: "28.12", description: "Campo note" },
  ],
  tipoCommGestioneSeparataOptions: [
    { code: "30.1", description: "Percentuale fissa" },
    { code: "30.2", description: "Fasce cumulo capitale" },
    { code: "30.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "30.4", description: "Percentuale funzione del tempo" },
    { code: "30.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "30.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "30.7", description: "Fasce premi versati annui" },
    { code: "30.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "30.9", description: "Percentuale del rendimento"},
    { code: "30.10", description: "Campo note" },
  ],
  tipoCommFondiInterniAzionariOptions: [
    { code: "32.1", description: "Percentuale fissa" },
    { code: "32.2", description: "Fasce cumulo capitale" },
    { code: "32.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "32.4", description: "Percentuale funzione del tempo" },
    { code: "32.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "32.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "32.7", description: "Fasce premi versati annui" },
    { code: "32.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "32.9", description: "Non presente"},
    { code: "32.10", description: "Campo note" },
  ],
  tipoCommFondiInterniObbligazionariOptions: [
    { code: "34.1", description: "Percentuale fissa" },
    { code: "34.2", description: "Fasce cumulo capitale" },
    { code: "34.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "34.4", description: "Percentuale funzione del tempo" },
    { code: "34.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "34.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "34.7", description: "Fasce premi versati annui" },
    { code: "34.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "34.9", description: "Non presente"},
    { code: "34.10", description: "Campo note" },
  ],
  tipoCommFondiInterniBilanciatiOptions: [
    { code: "36.1", description: "Percentuale fissa" },
    { code: "36.2", description: "Fasce cumulo capitale" },
    { code: "36.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "36.4", description: "Percentuale funzione del tempo" },
    { code: "36.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "36.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "36.7", description: "Fasce premi versati annui" },
    { code: "36.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "36.9", description: "Non presente"},
    { code: "36.10", description: "Campo note" },
  ],
  tipoCommFondiInterniFlessibiliOptions: [
    { code: "38.1", description: "Percentuale fissa" },
    { code: "38.2", description: "Fasce cumulo capitale" },
    { code: "38.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "38.4", description: "Percentuale funzione del tempo" },
    { code: "38.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "38.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "38.7", description: "Fasce premi versati annui" },
    { code: "38.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "38.9", description: "Non presente"},
    { code: "38.10", description: "Campo note" },
  ],
  tipoCommFondiInterniMonetariOptions: [
    { code: "40.1", description: "Percentuale fissa" },
    { code: "40.2", description: "Fasce cumulo capitale" },
    { code: "40.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "40.4", description: "Percentuale funzione del tempo" },
    { code: "40.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "40.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "40.7", description: "Fasce premi versati annui" },
    { code: "40.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "40.9", description: "Non presente"},
    { code: "40.10", description: "Campo note" },
  ],
  tipologiaCommissioneOICROptions: [
    { code: "42.1", description: "Percentuale fissa" },
    { code: "42.2", description: "Fasce cumulo capitale" },
    { code: "42.3", description: "Fasce a scaglioni cumulo capitale (criterio Irpef)" },
    { code: "42.4", description: "Percentuale funzione del tempo" },
    { code: "42.5", description: "Fasce cumulo capitale funzione del tempo" },
    { code: "42.6", description: "Fasce a scaglioni cumulo capitale (criterio Irpef) funzione del tempo" },
    { code: "42.7", description: "Fasce premi versati annui" },
    { code: "42.8", description: "Fasce premi versati annui funzione del tempo" },
    { code: "42.9", description: "Campo note" },
  ],
  commissioniOverperformanceOptions: [
    { code: "48.1", description: "Sì" },
    { code: "48.2", description: "No" },
  ],
  applicazioneCommissioniUscitaOptions: [
    { code: "50.1", description: "Sì" },
    { code: "50.2", description: "No" },
    { code: "50.3", description: "Campo note" },
  ],
  KIDOptions: [
    { code: "52.1", description: "Sì" },
    { code: "52.2", description: "No" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
};

const selectChoices = {
  mercato: { code: "", description: "" },
  destinatari: { code: "", description: "" },
  canale: { code: "", description: "" },
  tipoProdotto: { code: "", description: "" },
  tipoSottostanti: { code: "", description: "" },
  prodComm: { code: "", description: "" },
  tipoPremio: { code: "", description: "" },
  prodCollegato: { code: "", description: "" },
  relazioneProdCollegato: { code: "", description: "" },
  tipologiaDuration: { code: "", description: "" },
  tipoCalcoloBonusIngresso: { code: "", description: "" },
  tipoCalcoloBonusFedelta: { code: "", description: "" },
  tipologiaUpfrontFee: { code: "", description: "" },
  tipoCommGestioneSeparata: { code: "", description: "" },
  tipoCommFondiInterniAzionari: { code: "", description: "" },
  tipoCommFondiInterniObbligazionari: { code: "", description: "" },
  tipoCommFondiInterniBilanciati: { code: "", description: "" },
  tipoCommFondiInterniFlessibili: { code: "", description: "" },
  tipoCommFondiInterniMonetari: { code: "", description: "" },
  tipologiaCommissioneOICR: { code: "", description: "" },
  commissioniOverperformance: { code: "", description: "" },
  applicazioneCommissioniUscita: { code: "", description: "" },
  KID: { code: "", description: "" },
};

export { selectChoices };
export default data;
